<template>
  <div class="box">
    <div class="image-type-1">
      <img v-if="data.images" :src="data.images"/>
      <img v-else src="../../assets/default.png"/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ImagePreview',
  props: {
    data: Object
  }
}
</script>
<style scoped>
.box {
  text-align: center;
}
.box .image-type-1 {
  width: 100%;
  height: 215px;
  background-color: #f0f0f0;
  border-radius: 10px;
}
.box .image-type-2 {
  background-color: #f0f0f0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  padding-top: 170px;
}
.box img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/image/ImagePreview.vue